import { useContext, useEffect, Suspense, useMemo } from "react";
import BaseComponent from "common/Components/BaseComponent";
import "./Home.styles.css";
import AppContext from "common/Context/AppContext";
import UserContext from "common/Context/UserContext";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { syncCustomerHeadersFromProfile } from "common/HttpClient/CustomerContextHeaders";
import CustomTabs from "common/Components/Tabs/CustomTabs";
import { isPlatformAdminProfile } from "common/Utilities/Role.utils";
import { resetPlatformAdminCustomerSelection } from "common/Utilities/CustomerSelection.utils";
import { useEffectiveAccess } from "common/Context/EffectiveAccessContext";

export default function Home() {
  const { updateNavigationItem } = useContext(AppContext);
  const { userProfile } = useContext(UserContext);
  const { filterTabsByAccess, canReturnToApplication } = useEffectiveAccess();

  const profile = userProfile?.profile ?? {};
  const isPlatformAdmin = isPlatformAdminProfile(profile);

  const pageRoutes = isPlatformAdmin
    ? INFRAMARK_CONSTANTS.userRoutes.superAdminRoutes
    : INFRAMARK_CONSTANTS.userRoutes.userAdminRoutes;
  const showHeaderButton = {
    ...pageRoutes?.headerButton,
    showButton: !isPlatformAdmin && canReturnToApplication(),
  };
  const accessibleTabs = useMemo(
    () => filterTabsByAccess(pageRoutes?.accessiblePages ?? []),
    [filterTabsByAccess, pageRoutes?.accessiblePages]
  );

  useEffect(() => {
    if (isPlatformAdmin) {
      resetPlatformAdminCustomerSelection();
    } else {
      syncCustomerHeadersFromProfile(profile);
    }
    updateNavigationItem("Home");
  }, []);

  return (
    <BaseComponent>
      <Suspense fallback={<div>Loading...</div>}>
        <CustomTabs
          headerTitle={pageRoutes.headerTitle}
          headerButton={showHeaderButton}
          tabs={accessibleTabs}
        />
      </Suspense>
    </BaseComponent>
  );
}
